import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "changeDescription.title",
    },
    label: {
        id: "newTest.label",
    },
    description: {
        id: "newTest.description",
    },
    rename: {
        id: "changeDescription.submit",
    },
    cancel: {
        id: "general.cancel",
    },
});

export default messages;
